import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { BusinessUnitIdService } from '../services/business-units/business-unit-id.service';

@Injectable()
export class ImpersonateUserInterceptor implements HttpInterceptor {
    constructor(private businessUnitIdService: BusinessUnitIdService) { }

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        const businessUnitId = this.businessUnitIdService.getBusinessUnitId();
        if (businessUnitId != null) {
            let modifiedHeaders = request.headers.set('X-Impersonate', 'true');
            modifiedHeaders = modifiedHeaders.set('X-BusinessUnitId', businessUnitId.toString());

            const modifiedRequest = request.clone({ headers: modifiedHeaders });

            return next.handle(modifiedRequest);
        }

        return next.handle(request);
    }
}
